import React, { useContext } from 'react';
import { Appbar, List } from 'react-native-paper';
import { useQuery } from '@apollo/client';
import { NativeBaseProvider, ScrollView, View } from 'native-base';
import { useToast } from 'react-native-toast-notifications';
import { styles } from '../Common.style';
import { FindManySeasons } from '../../gql/season/query';
import { ModalContext } from '../../context/ModalContext';
import CreateSeasonModal from '../../modals/ManageSeason/CreateSeasonModal';
import LoadingIndicator from '../../components/commons/LoadingIndicator';

function ManageSeasons() {
  const toast = useToast();
  const {
    displayCreateSeasonModal,
    toggleCreateSeasonModal,
  } = useContext(ModalContext);

  const { data, loading, refetch } = useQuery(FindManySeasons);

  return (
    <>
      {displayCreateSeasonModal && <CreateSeasonModal />}
      <View style={styles.container}>
        {loading && <LoadingIndicator text="Chargement des saisons..." />}
        <Appbar.Header>
          <Appbar.Content title="Gérer les saisons" />
          <Appbar.Action
            icon="message-plus"
            onPress={toggleCreateSeasonModal}
          />
        </Appbar.Header>
        <ScrollView>
          {data?.findManySeasons?.map((d) => (
            <List.Item
              key={d.id}
              title={`${d.name}`}
              description={`Du ${new Date(d.startDate).toLocaleDateString()} au ${new Date(d.endDate).toLocaleDateString()}`}
            />
          ))}
        </ScrollView>
      </View>
    </>
  );
}

export default function ManageSeasonsScreen() {
  return (
    <NativeBaseProvider>
      <ManageSeasons />
    </NativeBaseProvider>
  );
}
